<template>
  <div :class="pcsub?'LogoMenuWrapper':''">
    <img src="static/img/banner_1.jpg" class="pc_banner" />
    <!-- pc -->
    <div class="pc_menu" v-if="loadmounted">
      <img src="static/img/logo.png" />
      <ul class="menu">
        <li class="index"><router-link to="/index">首页</router-link></li>
        <li v-for="(item,index) in menuList" :key="index">
          <a href="javascript:;" v-if="item.isShowSubMenu" :class="activeName == item.name?'link-active':''">{{ item.name }}</a>
          <router-link v-else :to="{ path: item.url, query:{ name: item.name, topicId: item.id } }" :class="activeName == item.name?'link-active':''">{{ item.name }}</router-link>
          <div class="subnav noactiveSub" v-if="item.id == 9">
            <a href="https://meetingch.tunnelling.cn/" target="_blank">2018年</a>
            <a href="https://www.tunnelling.cn/PSpecial/ICIM.aspx" target="_blank">2016年</a>
          </div>
          <div class="subnav noactiveSub" v-else-if="item.isShowSubMenu">
            <router-link v-for="(it,ind) in item.subMenus" :key="ind" :to="{ path: item.url, query:{ name: item.name, subName: it.name, topicId: item.id } }">{{ it.name }}</router-link>
          </div>
        </li>
      </ul>
    </div>
    <!-- mobile -->
    <div v-else :class="issub?'subLogoMenu LogoMenu':'IndexLogoMenu LogoMenu'">
      <img src="static/img/logo.png" />
      <span @click="CloseOpenFn(0)"></span>
      <div class="MenuCoverWrap" v-show="isshow">
        <div :class="issub?'subLogo-Menu logo-menu':'IndexLogo-Menu logo-menu'">
          <img src="static/img/logo.png" />
          <span @click="CloseOpenFn(1)"></span>
        </div>
        <ul class="menu">
          <li class="index"><router-link to="/index">首页</router-link></li>
          <li v-for="(item,index) in menuList" :key="index">
            <router-link v-if="!item.isShowSubMenu" :class="activeName == item.name?'link-active':''" :to="{ path: item.url, query:{ name: item.name, topicId: item.id } }">{{ item.name }}</router-link>
            <a href="javascript:;" v-else :class="activeName == item.name?'link-active':''" @click="MobileShowNavFn(index)">{{ item.name }}</a>
            <div class="subnav" v-if="item.id == 9">
              <div :class="activeSubInd == index?'activeSub':'noactiveSub'">
                <a href="https://meetingchm.tunnelling.cn/">2018年</a>
                <a href="https://www.tunnelling.cn/PSpecial/ICIM.aspx">2016年</a>
              </div>
            </div>
            <div class="subnav" v-else-if="item.isShowSubMenu">
              <div :class="activeSubInd == index?'activeSub':'noactiveSub'">
                <router-link v-for="(it,ind) in item.subMenus" :key="ind" :to="{ path: item.url, query:{ name: item.name, subName: it.name, topicId: item.id } }">{{ it.name }}</router-link>
              </div>
            </div>
          </li>
        </ul>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    MenuNavListApi
  } from '../request/api.js'
  export default {
    name: "LogoMenu",
    data() {
      return {
        isshow: false, // 是否展示菜单栏弹窗
        menuList: [], // 菜单
        activeSubInd: -1,
        lastSubInd: -1,
        nowClickNum: 0
      }
    },
    props: {
      issub: {
        type: Boolean,
        default: false
      },
      loadmounted: {
        type: Boolean,
        default: false
      },
      pcsub: {
        type: Boolean,
        default: true
      },
      activeName: {
        type: String,
        default: ''
      }
    },
    mounted() {
      if (this.loadmounted) {
        this.GetMenuNavFn();
      }
    },
    methods: {
      // 移动端的展开与收起
      MobileShowNavFn(i){
        this.activeSubInd = i;
      },
      // 打开-关闭 导航栏弹窗
      CloseOpenFn(num) {
        if (num == 0) {
          this.isshow = true;
          document.documentElement.style.overflowY = 'hidden'; //禁止底层div滚动
          if (this.menuList.length != 0) return;
          this.GetMenuNavFn();
        } else {
          this.isshow = false;
          document.documentElement.style.overflowY = 'auto'; //取消禁止屏幕滚动
        }
      },
      // 获取菜单
      GetMenuNavFn() {
        MenuNavListApi({
          IsRecommend: true,
          PageSize: 20,
          PageNumber: 1,
          Sorting: 'displayindex asc,creationdate asc'
        }).then(res => {
          this.menuList = res.items;
        })
      }
    }
  }
</script>

<style scoped>
  @media screen and (min-width: 1029px) {
    .LogoMenu>span,.subLogoMenu>img {
      display: none;
    }

    .LogoMenuWrapper{
      width: 100%;
      position: relative;
    }

    .LogoMenuWrapper>img{
      width: 100%;
      height: auto;
    }

    .pc_menu{
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      height: 80px;
      background: rgba(0, 0, 0, .4);
    }

    .menu_end{
      justify-content: flex-end !important;
    }

    .menu {
      display: flex;
    }

    .menu li{
      position: relative;
    }

    .menu li:hover .subnav{
      max-height: 600px;
    }

    .menu li>a {
      display: block;
      font-size: 16px;
      color: #ffffff;
      padding: 0 16px;
      position: relative;
      line-height: 60px;
    }

    .menu li>.link-active::after, .menu .index .router-link-active::after {
      content: ' ';
      position: absolute;
      bottom: -10px;
      left: 0;
      display: block;
      height: 2px;
      width: 100%;
      background-color: #FFFFFF;
    }

    .activeSub{
      max-height: 600px;
      overflow: auto;
      transition: max-height .3s;
    }

    .noactiveSub {
      max-height: 0;
      overflow: hidden;
      transition: max-height .3s;
    }

    .subnav{
      position: absolute;
      background: rgba(0, 0, 0, .3);
      width: 96px;
      top: 50px;
      z-index: 999;
    }

    .subnav a{
      display: block;
      color: #fff;
      height: 36px;
      line-height: 36px;
      overflow: hidden;
      cursor: pointer;
      text-align: center;
    }

    .subnav a:hover{
      color: #2468f2;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1024px) {
    .pc_banner{
      display: none;
    }

    /* 顶部菜单+logo */
    .LogoMenu,
    .logo-menu {
      display: flex;
    }

    .subLogoMenu,
    .subLogo-Menu {
      align-items: flex-end;
      flex-direction: column-reverse;
    }

    .subLogo-Menu {
      padding: 0 .3rem;
    }

    .IndexLogoMenu,
    .IndexLogo-Menu {
      align-items: center;
      justify-content: space-around;
      height: 1rem;
    }

    .subLogoMenu img,
    .subLogo-Menu img {
      width: 95%;
    }

    .subLogoMenu>span,
    .subLogo-Menu>span {
      margin: .33rem 0;
    }

    .IndexLogoMenu img,
    .IndexLogo-Menu img {
      width: 75%;
    }

    .LogoMenu>span {
      background: url(../assets/image/menu_icon.png) no-repeat center center;
      background-size: contain;
    }

    .logo-menu>span {
      background: url(../assets/image/close_icon.png) no-repeat center center;
      background-size: contain;
    }

    .LogoMenu>span,
    .logo-menu>span {
      display: inline-block;
      width: .4rem;
      height: .32rem;
    }

    /* 菜单栏弹窗 */
    .MenuCoverWrap {
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .8);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 13;
    }

    .MenuCoverWrap .menu {
      text-align: center;
      margin-top: 15%;
    }

    .MenuCoverWrap .menu a {
      display: block;
      color: #FFFFFF;
      font-size: .4rem;
      width: 2rem;
      text-align: center;
      margin: 0 auto .2rem;
    }

    .MenuCoverWrap .subnav a{
      font-size: .28rem;
    }

    .MenuCoverWrap .menu .link-active,.MenuCoverWrap .index .router-link-active{
      color: #2468f2;
    }

    .activeSub{
      max-height: 600px;
      overflow: auto;
      transition: max-height .3s;
    }

    .noactiveSub {
      max-height: 0;
      overflow: hidden;
      transition: max-height .3s;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LogoMenu.vue